var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"sidebar-toggle-btn",class:{ expanded: _vm.isExpanded },attrs:{"title":_vm.isExpanded ? 'Contraer menú' : 'Expandir menú'},on:{"click":_vm.toggleSidebar,"mouseover":_vm.toggleSidebar}},[_c('i',{staticClass:"material-icons toggle-icon"},[_vm._v(_vm._s(_vm.isExpanded ? "chevron_left" : "chevron_right"))])])
}
var staticRenderFns = []

export { render, staticRenderFns }